import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['title', 'description']> = defineContent({
	default: {
		title: {
			id: 'test-messages.test-message-narrow-exposure-experiment-v2.title.no-translate',
			defaultMessage: 'Post Office narrow-exposure v2 test message',
			description: 'Heading of the narrow-exposure v2 test message',
			role: 'title',
		},
		description: {
			id: 'test-messages.test-message-narrow-exposure-experiment-v2.description.no-translate',
			defaultMessage: 'This message tests the second narrow-exposure experiment.',
			description: 'Body of the narrow-exposure v2 test message',
			role: 'description',
		},
	},
});
